import { MessageTemplateTypes } from "@enums/message-template-types";

export const messageTemplateContentStringRegex = /\${\((.*?)\)(.*?)"}/g;

export const MESSAGE_TEMPLATE_SUBJECT_VARIABLE_NAME = "subject";
export const MESSAGE_TEMPLATE_URL_VARIABLE_NAME = "url";

export const MESSAGE_TEMPLATE_REQUIRED_URL_VARIABLE = `\${(${MESSAGE_TEMPLATE_URL_VARIABLE_NAME})!"URL_ERROR"}`;

export const DEFAULT_EMAIL_MESSAGE_TEMPLATE = `<html>
    <body>
        Click on this <a href='\${(${MESSAGE_TEMPLATE_URL_VARIABLE_NAME})!"URL_ERROR"}'>link</a> to begin the verification process.
    </body>
</html>`;
    
export const DEFAULT_SMS_MESSAGE_TEMPLATE = `Click on this link: \${(${MESSAGE_TEMPLATE_URL_VARIABLE_NAME})!"URL_ERROR"} to begin the verification process.`;

export const REQUIRED_MESSAGE_TEMPLATE_VARIABLES = [
    MESSAGE_TEMPLATE_URL_VARIABLE_NAME,
    MESSAGE_TEMPLATE_SUBJECT_VARIABLE_NAME
];

export const MESSAGE_TEMPLATE_TYPE_OPTIONS = [
    {
        label: MessageTemplateTypes.EMAIL,
        value: MessageTemplateTypes.EMAIL
    },
    {
        label: MessageTemplateTypes.SMS,
        value: MessageTemplateTypes.SMS
    }
]